// File authentication.reducer.ts
/* eslint-disable @typescript-eslint/no-explicit-any */
import jwt_decode from 'jwt-decode';
import { userConstants } from '../../constants';

export interface UserInfo {
  id?: string;
  email?: string;
  userName?: string;
  role?: number;
  avatar?: string;
  createAt?: string;
  studentId?: string;
}
export interface AuthenticationState {
  loggingIn?: boolean;
  loggedIn?: boolean;
  error?: string;
  userInfo?: UserInfo;
}

export interface Action {
  type: string;
  payload?: any;
}

// Initialize state from localStorage (decode token properly)
const initialState: AuthenticationState = (() => {
  try {
    const accessToken = localStorage.getItem('accessToken');
    if (accessToken) {
      // Token is already a string, no need to parse
      const decoded: UserInfo = jwt_decode(accessToken);
      return { 
        loggedIn: true, 
        userInfo: decoded 
      };
    }
  } catch (e) {
    console.error("Error decoding accessToken:", e);
    // Clear invalid tokens
    localStorage.removeItem('accessToken');
    localStorage.removeItem('userInfo');
  }
  return {};
})();


export const authentication = (state: AuthenticationState = initialState, action: Action) => {
  switch (action.type) {
    case userConstants.LOGIN_REQUEST:
      return {
        loggingIn: true,
        loggedIn: false
      };
    case userConstants.LOGIN_SUCCESS:
      return {
        loggingIn: false,
        loggedIn: true,
        userInfo: action.payload
      };
    case userConstants.LOGIN_FAILURE:
      return {
        loggingIn: false,
        loggedIn: false,
        error: action.payload
      };
    case userConstants.LOGOUT:
      return {};
    default:
      return state;
  }
};
